import CardElementPhotoImage from './CardElementPhotoImage';

export default CardElementPhotoImage;
